import * as React from 'react';
var PortalCompatContext = /*#__PURE__*/React.createContext(undefined);

var portalCompatContextDefaultValue = function () {
  return function () {
    return undefined;
  };
};

export var PortalCompatContextProvider = PortalCompatContext.Provider;
export function usePortalCompat() {
  var _a;

  return (_a = React.useContext(PortalCompatContext)) !== null && _a !== void 0 ? _a : portalCompatContextDefaultValue;
}
//# sourceMappingURL=PortalCompatContext.js.map